import { render, staticRenderFns } from "./CanalCobroShow.vue?vue&type=template&id=ebacbf1c"
import script from "./CanalCobroShow.vue?vue&type=script&lang=js"
export * from "./CanalCobroShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports